import { signal } from 'kerfjs';

import { demandReadOnly, isRequester } from '../lib/context.js';
import { loadBool, saveBool } from '../lib/prefs.js';
import {
  type PricingCheckControlState,
  pricingCheckControlState,
  pricingPromptPrefKey,
} from '../lib/pricing-check-control.js';
import { analysisList, analysisRunning, workspace } from './state.js';

/** The pricing-check control state for the open demand and current viewer. */
export function currentPricingCheckState(view: string): PricingCheckControlState {
  return pricingCheckControlState({
    onDemand: view === 'workspace' || view === 'intake',
    requester: isRequester(),
    readOnly: demandReadOnly(),
    hasLines: ((workspace.value?.lineItems as unknown[] | undefined) ?? []).length > 0,
    running: analysisRunning.value,
    hasAnalysis: analysisList.value.length > 0,
  });
}

/**
 * Per-viewer dismissal of the demand editor's "run a pricing check" prompt
 * (HS2-CNXFTE), remembered per demand in localStorage. The signal only bumps on a
 * dismissal so the banner re-renders; prefs hold the truth across reloads.
 */
const dismissals = signal(0);

/** Whether this viewer dismissed the prompt on this demand. */
export function pricingPromptDismissed(demandId: string): boolean {
  // Read the signal so a dismissal re-renders; prefs hold the value.
  return dismissals.value >= 0 && loadBool(pricingPromptPrefKey(demandId), false);
}

/** Hide the prompt on this demand for this viewer, now and after reloads. */
export function dismissPricingPrompt(demandId: string): void {
  saveBool(pricingPromptPrefKey(demandId), true);
  dismissals.value += 1;
}
